module.exports = __webpack_public_path__ + "static/images/left-arrow-black.vnqyvJk.svg";